import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./E1RegularCheck.scss"

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const E1RegularCheck = forwardRef(({ e1MonitoringPlanChecks, vesselMstId,refetchMonitoringData }, ref) => {
    
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (e1MonitoringPlanChecks) {
            reset(prev => ({ ...prev, e1: e1MonitoringPlanChecks }));
        }
    }, [e1MonitoringPlanChecks, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("e1");
        const payload = {
            ...filteredFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const e1RegularCheck = await callApi({
                method: "POST",
                url: API_ROUTES.E1(vesselMstId),
                data: payload,
            });
            if (e1RegularCheck?.isSuccess) {
                emitToasterMsg("success", "Table E.1", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, e1: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table E.1", e1RegularCheck?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table E.1", error?.errorMessage);
        }
    };

    const filteredFields = cSectionFormFields
        .filter(field => field.name !== "formulaeAndDataSources")
        .map(field => {
            if (field.name === "referenceToProcedure") {
                return {
                    ...field,
                    label: "Reference for procedure",
                };
            }
            return field;
        });

    return (
        <div className="e1-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Regular check of the adequacy of the monitoring plan</h6>
                </MDBCol>
            </MDBRow>

            {filteredFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`e1.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`e1_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="e1_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                     disabled={!isDirty}
                >Save</Button>
            </div>
        </div>
    );
});

export default E1RegularCheck;